module.exports = __webpack_public_path__ + "static/media/feature_flag_description_mobile_en.f7217e4a.png";